import React, { ReactElement } from "react";
import { IconProps } from "../Icon.types";

const GlobeIcon = ({
  size = "1em",
  fill = "#343A40",
  title = "",
  iconClass = "",
  className,
  ...props
}: IconProps): ReactElement => {
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      version="1.1"
      className={className || iconClass}
    >
      <title>{title}</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill={fill}>
          <path d="M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 L12,23 C5.92486775,23 1,18.0751322 1,12 C1,6.02129842 5.76976358,1.15663482 11.7115925,1.0037074 L12,1 L12,1 L12,1 Z M7.05279391,13.0010636 L3.05500569,13.0006955 C3.46835632,16.7372697 6.16921492,19.7842959 9.72607502,20.7102675 C8.2052792,18.4233136 7.28166193,15.7770381 7.05279391,13.0010636 Z M20.9449943,13.0006955 L16.9498422,13.0008226 C16.7255335,15.7635472 15.8008579,18.4154858 14.2745676,20.7097575 C17.8312897,19.7837266 20.5316823,16.7369207 20.9449943,13.0006955 Z M14.945194,13.0003647 L9.05765422,13.0006768 C9.30895924,15.713613 10.3304698,18.2982679 12.0000219,20.4492318 C13.6759302,18.2904611 14.6988433,15.6975901 14.945194,13.0003647 Z M9.72543244,3.29024251 L9.6892238,3.29941009 C6.15025532,4.23685972 3.46644779,7.27618877 3.05489527,11.0003032 L7.05007662,11.0001782 C7.27424317,8.2370933 8.19895783,5.58479128 9.72543244,3.29024251 Z M11.9999781,3.5507682 C10.3238625,5.70980581 9.30090373,8.30305111 9.05471464,11.0006358 L14.9424384,11.0003233 C14.6912918,8.28702224 13.6697354,5.70199636 11.9999781,3.5507682 Z M14.273925,3.2897325 L14.4629614,3.58063524 C15.8714653,5.80010201 16.728192,8.34051478 16.9472885,10.9999359 L20.9451047,11.0003032 C20.5321249,7.26327319 17.831102,4.21578659 14.273925,3.2897325 Z" />
        </g>
      </g>
    </svg>
  );
};

export { GlobeIcon };
